import React, { forwardRef, Suspense } from 'react';
import type ReCAPTCHA from 'react-google-recaptcha';

const ReCAPTCHAComponent = React.lazy(() => import('react-google-recaptcha'));

const LazyReCAPTCHA = forwardRef<ReCAPTCHA, React.ComponentProps<typeof ReCAPTCHAComponent>>((props, ref) => {
  return (
    <Suspense fallback={<div className="h-[78px] bg-muted animate-pulse rounded-md" />}>
      <ReCAPTCHAComponent ref={ref} {...props} />
    </Suspense>
  );
});

LazyReCAPTCHA.displayName = 'LazyReCAPTCHA';

export default LazyReCAPTCHA;
